import { TableProps } from "@/ui/tables/Table";
import { Badge, Button, Text } from "@chakra-ui/react";
import { WorkOrder } from "./type/WorkOrder";
import { formatPrice } from "@/utils/formatPrice";
import TruncateText from "@/utils/TruncateText";
import { CreatorCell } from "../vouchers/Columns";

export const WorkOrdersTableColumns = (
  handleToggleEnabled: (workOrder: WorkOrder) => void,
): TableProps<WorkOrder>["headers"] => {
  return [
    {
      label: "Nombre",
      itemLabel: (item) => (
        <TruncateText maxWidth={200}>{item.name}</TruncateText>
      ),
      sortable: true,
      sortKey: "name",
    },
    {
      label: "Código",
      itemLabel: (item) => <Text fontWeight="semibold">{item.code}</Text>,
      sortable: true,
      sortKey: "code",
    },
    {
      label: "Costo",
      itemLabel: (item: WorkOrder) => formatPrice(item.totalVoucherPrices || 0),
    },
    {
      label: "Empresa",
      itemLabel: (item: WorkOrder) => item.clientEntity.name || "Sin empresa",
      sortable: true,
      sortKey: "clientEntity",
    },
    {
      label: "OT Cerrada",
      itemLabel: (item: WorkOrder) =>
        item.closedWorkOrder ? (
          <Badge colorPalette="green" variant="subtle">
            Sí
          </Badge>
        ) : (
          <Badge colorPalette="gray" variant="subtle">
            No
          </Badge>
        ),
    },
    {
      label: "Fecha de creación",
      itemLabel: (item: WorkOrder) =>
        new Date(item.createdAt).toLocaleDateString("es-CL"),
    },
    {
      label: "Creado por",
      itemLabel: (item: WorkOrder) => <CreatorCell name={item.creator?.name} />,
    },
    {
      label: "Estado",
      itemLabel: (item: WorkOrder) => (
        <Button
          variant="ghost"
          size="sm"
          colorPalette={item.enabled ? "gray" : "green"}
          color={item.enabled ? "fg.muted" : undefined}
          onClick={() => handleToggleEnabled(item)}
        >
          {item.enabled ? "Deshabilitar" : "Habilitar"}
        </Button>
      ),
    },
  ];
};
